var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33388 11.2222C11.2976 11.2222 12.8894 9.82933 12.8894 8.11111C12.8894 6.39289 11.2976 5 9.33388 5C7.3702 5 5.77832 6.39289 5.77832 8.11111C5.77832 9.82933 7.3702 11.2222 9.33388 11.2222Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19V17.4444C4 16.6193 4.3746 15.828 5.0414 15.2445C5.70819 14.6611 6.61256 14.3333 7.55556 14.3333H11.1111C12.0541 14.3333 12.9585 14.6611 13.6253 15.2445C14.2921 15.828 14.6667 16.6193 14.6667 17.4444V19M15.5556 5.10107C16.3204 5.27242 16.9983 5.66162 17.4823 6.20732C17.9664 6.75301 18.2292 7.42416 18.2292 8.11496C18.2292 8.80576 17.9664 9.47691 17.4823 10.0226C16.9983 10.5683 16.3204 10.9575 15.5556 11.1289M20 19V17.4444C19.9955 16.7578 19.7315 16.0917 19.2491 15.5501C18.7668 15.0084 18.0932 14.6216 17.3333 14.45",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllUsers);
export default __webpack_public_path__ + "static/media/all-users.e4726768.svg";
export { ForwardRef as ReactComponent };